"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const _excluded = ["title", "description"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const home = _ref => {
  let {
      title,
      description
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? "title-home" : '') + (description ? " desc-home" : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-home"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-home"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4551 0.263908L2.49875 7.62222C2.18364 7.87932 1.99851 8.28021 2.00001 8.69142V22.1331C2.00001 22.8576 2.59977 23.4942 3.32577 23.4942H9.37123L9.49794 23.4877C10.1657 23.419 10.6969 22.815 10.697 22.1332L10.696 15.5492H13.803L13.803 22.1331C13.8031 22.8576 14.4028 23.4942 15.1288 23.4942H21.1743C21.9003 23.4942 22.5 22.8576 22.5 22.1331V8.68867C22.5 8.27858 22.3158 7.87887 21.9993 7.62057L13.077 0.288889C12.5018 -0.0973474 11.9326 -0.0868473 11.4551 0.263908ZM12.252 1.54819L21 8.74119V21.9942H15.303L15.303 14.7998C15.303 14.3856 14.9673 14.0498 14.553 14.0498H9.94699L9.84521 14.0566C9.47914 14.1063 9.19699 14.4201 9.19699 14.7998L9.19601 21.9942H3.50001V8.74019L12.252 1.54819Z",
    fill: "inherit"
  }));
};
var _default = exports.default = home;